import type { ISEOProps } from "../types/core";

export const ResetPasswordPageSEO: ISEOProps = {
  title: "Reset Password - Sugar Cribs",
  description:
    "Create a new password for your Sugar Cribs account. Enter your new password to complete the reset process.",
};
